import { createContext, useContext, useEffect, useState } from "react";
import { api, clearAuth, getStoredUser, getToken, setStoredUser, setToken } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(getStoredUser());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        setUser(res.data);
        setStoredUser(res.data);
      })
      .catch(() => {
        clearAuth();
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    setToken(res.data.token);
    setStoredUser(res.data.user);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    clearAuth();
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const ROLE_LABELS = {
  ceo: "CEO",
  director_marketing: "Director de Marketing",
  creador_interno: "Creador Interno",
  creador_ugc: "Creador UGC",
  disenador: "Diseñador/a Gráfico/a",
  filmmaker: "Filmmaker Comercial",
  filmmaker_ia: "Filmmaker IA",
  community_manager: "Community Manager",
  copywriter: "Copywriter",
  editor_video: "Editor de Video",
  analista: "Analista de Métricas",
};
